
const getters = {
  listAll: state => {
    return state.role_list
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/role/role.getters.js
// module id = null
// module chunks = 